"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function replaceTextRecursive(instance, key, value) {
    if (value === void 0) { value = ''; }
    if (Array.isArray(instance)) {
        for (var i = 0; i < instance.length; i++) {
            var child = instance[i];
            if (typeof child === 'string') {
                instance[i] = child.split(key).join(value);
            }
            else {
                replaceTextRecursive(child, key, value);
            }
        }
    }
    else if (typeof instance === 'object') {
        var keys = Object.keys(instance);
        for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
            var instanceKey = keys_1[_i];
            var child = instance[instanceKey];
            if (typeof child === 'string') {
                instance[instanceKey] = child.split(key).join(value);
            }
            else {
                replaceTextRecursive(child, key, value);
            }
        }
    }
    return instance;
}
exports.replaceTextRecursive = replaceTextRecursive;
//# sourceMappingURL=replaceTextRecursive.js.map